import CoreContent from '@core_modules/theme/plugins/magebirdpopup/components/core';
import { useRouter } from 'next/router';
import { getMagebirdPopup } from '@core_modules/theme/services/graphql';
import _ from 'lodash';
import { getPageType } from '@helpers/pageType';
import { getCartId } from '@helpers/cartId';

const core = (props) => {
    const {
        pageConfig,
        categoryId = 0,
        data: dataProduct,
        storeConfig,
    } = props;

    const router = useRouter();
    const fullUrl = `${window.location.host}${router.asPath}`;

    const cartId = getCartId() || '';
    const pageType = getPageType(pageConfig?.pageType);
    const [dataPopup, setDataPopup] = React.useState([]);

    const { data, loading, error } = getMagebirdPopup({
        page: pageType,
        url: fullUrl,
        cartId,
        ...pageType === 'category-page' && { categoryId },
        ...pageType === 'product-page' && { sku: dataProduct?.products?.items[0]?.sku },
    });

    React.useEffect(() => {
        if (!_.isEmpty(data?.getMagebirdPopup?.data) && !loading && !error) {
            setDataPopup(data?.getMagebirdPopup?.data);
        }
    }, [data, loading, error]);

    return (
        <>
            {dataPopup.length > 0 && (
                <>
                    {dataPopup.map((item, index) => (
                        <div key={index}>
                            <CoreContent data={item} dataPopup={dataPopup} storeConfig={storeConfig} />
                        </div>
                    )) }
                </>
            )}
        </>
    );
};

export default core;
